// extracted by mini-css-extract-plugin
module.exports = {"container":"Table_container__DgnTw","row":"Table_row__3hAub"};